import { OutputSelector } from 'reselect'
import { createDeepEqualSelector } from 'Redux/selectors/index'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getState = (state: any) => state.spotifyToken

export const getCountry = createDeepEqualSelector(
  getState,
  ({ country }) => country
)

export const getSpotifyToken: OutputSelector<
  [],
  string,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ accessToken }) => accessToken)
